import * as React from "react";
const SvgGoogle = props => <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" viewBox="0 0 64 64" {...props}><path d="M58.148 26.777H56v-.109H32v10.664h15.07C44.871 43.543 38.965 48 32 48c-8.836 0-16-7.164-16-16s7.164-16 16-16c4.078 0 7.79 1.54 10.613 4.05l7.543-7.542C45.395 8.07 39.023 5.332 32 5.332 17.273 5.332 5.332 17.273 5.332 32c0 14.727 11.941 26.668 26.668 26.668 14.727 0 26.668-11.941 26.668-26.668 0-1.79-.184-3.535-.52-5.223Zm0 0" style={{
    stroke: "none",
    fillRule: "nonzero",
    fill: "#fbc02d",
    fillOpacity: 1
  }} /><path d="m8.406 19.59 8.762 6.422C19.539 20.145 25.281 16 32 16c4.078 0 7.79 1.54 10.613 4.05l7.543-7.542C45.395 8.07 39.023 5.332 32 5.332c-10.242 0-19.125 5.785-23.594 14.258Zm0 0" style={{
    stroke: "none",
    fillRule: "nonzero",
    fill: "#e53935",
    fillOpacity: 1
  }} /><path d="M32 58.668c6.887 0 13.148-2.637 17.879-6.926l-8.254-6.98A15.876 15.876 0 0 1 32 48c-6.938 0-12.824-4.422-15.043-10.594l-8.695 6.7C12.672 52.741 21.637 58.667 32 58.667Zm0 0" style={{
    stroke: "none",
    fillRule: "nonzero",
    fill: "#4caf50",
    fillOpacity: 1
  }} /><path d="m58.148 26.777-.023-.109H32v10.664h15.07a16.036 16.036 0 0 1-5.449 7.43s.004 0 .004-.004l8.254 6.984c-.586.531 8.789-6.41 8.789-19.742 0-1.79-.184-3.535-.52-5.223Zm0 0" style={{
    stroke: "none",
    fillRule: "nonzero",
    fill: "#1565c0",
    fillOpacity: 1
  }} /></svg>;
export { SvgGoogle as ReactComponent };
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSAiaHR0cHM6Ly9kMmphdTJ3N3pjMWU3bS5jbG91ZGZyb250Lm5ldC9wYWNrcy9mOGEwMjAwYzQ5MDRhM2MxNDU0MWNmZjk3NDFlOTIzZS5zdmciOw==";